import axios from "axios";
import { getSessionId } from "../../../../../utils/tokenHandlers";
export const updateKeyPersonUpload = (id: number, docId: number) => {
  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/update/one/tradexwbench.customer_key_person/${id}`,
      {
        params: {
          context: {},
          data: {
            signed_digio_key_id: docId,
            signed_key_form_status: "Physically Signed",
          },
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      // console.log(response);
      return response;
    })
    .catch((err) => err);
};
